import { api, apiUrl } from "../../shared/services/service";
import { AdvancedVesselSearchRequest } from "../models/advanced-vessel-search.models";

// Runs explicit filters and sorting on the server before pagination.
// Counts are always requested here and never enter the default search count cache.
export const searchAdvancedVessels = async (request: AdvancedVesselSearchRequest) => {
  return api.get(`${apiUrl}/advancedVesselSearch`, {
    signal: request.signal,
    params: {
      ...request.filters,
      activity: request.filters.activity || (request.showInactiveVessels ? "all" : "active"),
      vessel_name: request.search || undefined,
      page: request.page,
      pageSize: request.pageSize,
      includeCount: "true",
    },
  });
};
